/**
 * BMTM ("Buy Me To Try Me") cart banner — reveals the cart banner
 * (snippets/bmtm-cart-banner.liquid) only when the signed-in customer is
 * BMTM-eligible, per the DBM consultant-status probe:
 *
 *   GET /apps/consultant/api/extension/consultant-status
 *       -> { signed_in, is_consultant, bmtm: { eligible } | has_bmtm, ... }
 *
 * CACHE-SAFE (mirrors sections/login-bar.liquid): the banner ships HIDDEN for
 * every visitor — no Liquid `customer` read — so the cached cart HTML is
 * identical for everyone; this script reveals it client-side. GRACEFUL DEGRADE:
 * signed-out / not eligible / any error => it stays hidden.
 *
 * The cart drawer re-renders its innerHTML on every cart change (assets/theme.js
 * CartDrawer), recreating the banner hidden — so re-apply the last known
 * eligibility on cart-drawer:refreshed / cart:refresh.
 */
(function () {
  'use strict';
  if (window.__bmtmCartBannerInit) return; // one init even if two sections load us
  window.__bmtmCartBannerInit = true;

  var STATUS_URL = '/apps/consultant/api/extension/consultant-status';
  var CACHE_KEY = 'dbm_consultant_status'; // populated by login-bar; read-only here
  var eligible = false;

  // Tolerate the nested { bmtm: { eligible } } shape AND flat has_bmtm/hasBmtm,
  // mirroring assets/consultant-bff.js bmtmEligibleOf.
  function isEligible(s) {
    if (!s) return false;
    if (s.bmtm && s.bmtm.eligible) return true;
    return !!(s.has_bmtm || s.hasBmtm);
  }

  function apply() {
    var banners = document.querySelectorAll('[data-bmtm-cart-banner]');
    for (var i = 0; i < banners.length; i++) { banners[i].hidden = !eligible; }
  }
  function decide(s) { eligible = isEligible(s); apply(); }

  function boot() {
    // Stale-while-revalidate: paint from the shared cached status first (no
    // flash for an eligible consultant), then revalidate against the probe.
    try { var c = sessionStorage.getItem(CACHE_KEY); if (c) decide(JSON.parse(c)); } catch (e) {}

    fetch(STATUS_URL, { credentials: 'include', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (s) { if (s) decide(s); })
      .catch(function () { /* graceful degrade: stay hidden */ });

    // The drawer rebuilds on cart change (script tags in the re-rendered HTML do
    // NOT re-run), so this persistent listener re-reveals the fresh banner node.
    document.addEventListener('cart-drawer:refreshed', apply);
    document.addEventListener('cart:refresh', apply);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
